import { reactive } from 'vue'
import { useLoader } from './useLoader'
import { useError } from './useError'
import axios from '@/axios'

const initialVal = {
  id: null,
  editor_id: null,
  group_id: null,
  name: null,
  uname: null,
  email: null,
  start_date: null,
  end_date: null,
  phone: null,
  resign: null,
  remain_money: null,
  denomination_id: null,
  denomination_name: null,
  denomination_user_count: null,
  representative_name: null,
  is_lonely: null,
  profile_image: null,
  updated_at: null,
  role: {
    id: null,
    name: null,
    is_office_worker: null,
    is_authorizer: null,
    is_chair: null,
    rank: null
  }
}

const userState = reactive({
  currentUser: initialVal
})

export const useCurrentUser = () => {
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()
  const getCurrentUser = async () => {
    try {
    toggleShowLoader(true)
    const res = await axios
      .get('/auth/me')
      Object.assign(userState.currentUser, res.data.user)
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  return { getCurrentUser, currentUser: userState.currentUser}
}
